import { createContext, useCallback, useContext, useState } from "react";
import BookingModal from "@/components/site/BookingModal";

const BookingContext = createContext({ openBooking: () => {} });

export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openBooking = useCallback(() => setOpen(true), []);

  return (
    <BookingContext.Provider value={{ openBooking }}>
      {children}
      <BookingModal open={open} onOpenChange={setOpen} />
    </BookingContext.Provider>
  );
};
